import { environment } from '../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse } from '../dto/api-response.response';
import { SalesReportResponse } from '../dto/sales-report.response';
import { RemissionGuideReportResponse } from '../dto/remission-guide-report.response';

@Injectable({ providedIn: 'root' })
export class ReportService {

    private readonly baseUrl = `${environment.apiUrl}/reports`;

    constructor(private http: HttpClient) {}

    /**
     * GET /api/reports/sales
     * startDate y endDate requeridos (YYYY-MM-DD)
     * clientIds y productIds opcionales (ej: "1,2,3")
     */
    getSalesReport(
        startDate: string,
        endDate: string,
        clientIds?: string,
        productIds?: string,
        documentTypeCodes?: string,
    ): Observable<ApiResponse<SalesReportResponse>> {
        let params = new HttpParams()
            .set('startDate', startDate)
            .set('endDate', endDate);

        if (clientIds) params = params.set('clientIds', clientIds);
        if (productIds) params = params.set('productIds', productIds);
        if (documentTypeCodes) params = params.set('documentTypeCodes', documentTypeCodes);

        return this.http.get<ApiResponse<SalesReportResponse>>(`${this.baseUrl}/sales`, { params });
    }

    /**
     * GET /api/reports/remission-guides
     * startDate y endDate requeridos (YYYY-MM-DD); el resto son filtros opcionales.
     */
    getRemissionGuidesReport(
        startDate: string,
        endDate: string,
        filters?: { clientIds?: string; transferReasonIds?: string; otNumber?: string; status?: string },
    ): Observable<ApiResponse<RemissionGuideReportResponse>> {
        let params = new HttpParams()
            .set('startDate', startDate)
            .set('endDate', endDate);

        if (filters?.clientIds) params = params.set('clientIds', filters.clientIds);
        if (filters?.transferReasonIds) params = params.set('transferReasonIds', filters.transferReasonIds);
        if (filters?.otNumber) params = params.set('otNumber', filters.otNumber);
        if (filters?.status) params = params.set('status', filters.status);

        return this.http.get<ApiResponse<RemissionGuideReportResponse>>(`${this.baseUrl}/remission-guides`, { params });
    }
}
